/**
 * Where to go after signing in or signing up, from a `returnTo` query value.
 *
 * Same-origin paths only: "/teams/invites/abc" is honoured, while
 * "https://evil.example" and "//evil.example" fall back to the home page, so
 * the parameter cannot be used as an open redirect.
 */
export const safeReturnTo = (param?: string | null): string =>
  param?.startsWith("/") && !param.startsWith("//") ? param : "/";
